import { HOST, APP_NAME } from "config";

export const getTrendingCompanies = () => {
    return HOST + APP_NAME + '/trending_companies/'
}

// ─── Group A: receive history.location.search (full query string) ─────────────
// Do NOT encode `query` — it is already a well-formed query string.
// Encoding it would turn '?' and '&' into %3F/%26, breaking the URL structure.

export const getSearchURL = (searchTerm) => {
    return HOST + APP_NAME + '/companysearch/?search=' + encodeURIComponent(searchTerm)
}
export const getSearchURLForRatios = (sector_name, searchTerm) => {
    return HOST + APP_NAME + `/companysearchforratios/?sector_name=${encodeURIComponent(sector_name)}&search=${encodeURIComponent(searchTerm)}`
}
// http://localhost:8000/finalyze/companysearchforratios/?sector_name=FMCG&search=H
export const getCompanyInfo = (query) => {
    // query is a path segment (ticker symbol) — alphanumeric, no encoding needed
    return HOST + APP_NAME + '/companysearch/' + query + "/"
}

export const getProfitAndLoss = (query, period) => {
    // query = history.location.search (full query string) — must not be encoded
    // period is a scalar value — encode it
    return HOST + APP_NAME + '/profitandlossdata/' + query + '&period=' + encodeURIComponent(period)
}

export const getBalanceSheet = (query) => {
    return HOST + APP_NAME + '/balancesheetdata/' + query
}

export const getCashFlow = (query) => {
    return HOST + APP_NAME + '/cashflowdata/' + query
}

// ─── Group B: receive individual scalar values → encodeURIComponent on each ───

export const getPriceAndVolumeChart = (period, count, company__symbol) => {
    return HOST + APP_NAME + `/priceandvolumedata/?period=${encodeURIComponent(period)}&company__symbol=${encodeURIComponent(company__symbol)}&count=${encodeURIComponent(count)}`
}

export const getPeAndPbChart = (period, count, company__symbol) => {
    return HOST + APP_NAME + `/pepbratiodata/?period=${encodeURIComponent(period)}&company__symbol=${encodeURIComponent(company__symbol)}&count=${encodeURIComponent(count)}`
}

export const getBrand = (symbol) => {
    return HOST + APP_NAME + '/branddata/?symbol=' + encodeURIComponent(symbol)
}

export const getCompanyEssential = (query) => {
    return HOST + APP_NAME + '/companyessentialdata/' + query
}

export const getIndexPresence = (query) => {
    return HOST + APP_NAME + '/indexdata/?company__symbol=' + encodeURIComponent(query)
}

export const getPeerComparison = (query) => {
    return HOST + APP_NAME + '/peercomparison/?type=sector&symbol=' + encodeURIComponent(query)
}

export const getRatioChart = (query) => {
    return HOST + APP_NAME + '/ratio_data/' + query
}

export const getDupontAnalysis = (query) => {
    return HOST + APP_NAME + '/dupontanalysisdata/' + query
}

export const getRequiredAnalysis = (type, symbol) => {
    return HOST + APP_NAME + `/analysis_required_data/?type=${encodeURIComponent(type)}&symbol=${encodeURIComponent(symbol)}`
}

export const postRequiredAnalysis = (query) => {
    // query is a hardcoded path segment (e.g. '/dcf_analysis/') — not user input
    return HOST + APP_NAME + query
}

export const getProsAndCons = (symbol) => {
    return HOST + APP_NAME + `/pros_and_cons/?symbol=${encodeURIComponent(symbol)}`
}
export const getProsAndConsYears = (symbol) => {
    return HOST + APP_NAME + `/prosandcons_avail_dates/?symbol=${encodeURIComponent(symbol)}`
}

export const getPeAndPbRatio = (type, company__symbol) => {
    return HOST + APP_NAME + `/pepbratio/?type=${encodeURIComponent(type)}&company__symbol=${encodeURIComponent(company__symbol)}`
}

export const getPriceAndVolumeRatio = (type, company__symbol) => {
    return HOST + APP_NAME + `/priceandvolume/?type=${encodeURIComponent(type)}&company__symbol=${encodeURIComponent(company__symbol)}`
}

export const getRatiosData = (company__symbol) => {
    return HOST + APP_NAME + `/ratiosdata/?company__symbol=${encodeURIComponent(company__symbol)}`
}

export const getRatios = (company__symbol) => {
    return HOST + APP_NAME + `/ratios/?company__symbol=${encodeURIComponent(company__symbol)}`
}

export const getRatiosGraph = (name, company__symbol) => {
    return HOST + APP_NAME + `/ratios/?company__symbol=${encodeURIComponent(company__symbol)}&name=${encodeURIComponent(name)}`
}

export const getSectorAvgRatiosGraph = (ratio_name, sector) => {
    return HOST + APP_NAME + `/sector_ratio_avg/?sector=${encodeURIComponent(sector)}&ratio_name=${encodeURIComponent(ratio_name)}`
}